import { InteractiveContainer } from "@jugl-web/ui-components/cross-platform/InteractiveContainer";
import React from "react";
import { ReactComponent as MingcuteIcon } from "./assets/mingcute.svg";
import { ReactComponent as ArrowIcon } from "./assets/arrow.svg";

export const AIAssistantPromptSuggestion: React.FC<{
  prompt: string;
  onClick: () => void;
}> = ({ onClick, prompt }) => (
  <InteractiveContainer
    className="bg-grey-200 group flex items-center justify-center gap-2 rounded-xl p-3 transition-colors hover:bg-[#E8E0F4]"
    onClick={onClick}
  >
    <MingcuteIcon className="shrink-0" />
    <span className="text-dark font-secondary text-center text-sm leading-[21px]">
      {prompt}
    </span>
    <ArrowIcon className="opacity-0 transition-opacity group-hover:opacity-100" />
  </InteractiveContainer>
);
